import 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash-es';
import AppConstants from '../gorillaboy/AppConstants';
import SignalProvider from '../gorillaboy/SignalProvider';
import {FeatureNotificationService} from './FeatureNotificationService';
import {FeatureNotification, FeatureNotificationResponse} from './FeatureNotificationTypes';

angular.module('GorillaBoy.directives')
.directive('featureNotificationManager', ['$rootScope', '$log', '$uibPosition', '$timeout', 'FeatureNotificationService', '$window',
                                          ($rootScope:ng.IRootScopeService, $log:ng.ILogService, $uibPosition:any, $timeout:ng.ITimeoutService, FeatureNotificationService: FeatureNotificationService, $window: ng.IWindowService) => {

    var notifications:any = [];
    const NOTIFICATION_SPACE:number = 5;
    var featureNotificationList:FeatureNotification[];
    var uniqueFeatureName:string[] = [];

    return {
        scope: true,
        // The beacon element has an infinite animation which triggers layout and recalculate style which hurts
        // performance (especially PDFJS rendering). So do not render it unless there's a title
        template: `<div id="notification" ng-class="{'visible': showNotification}">
                      <span ng-if="!!title" class='beacon {{placement}}'></span>
                      <div class='ballon'>
                          <div class="title">{{title}}</div>
                          <div ng-bind-html="trustAsHtml(content)"></div>
                          <div class="footer">
                              <a ng-click="hideCurrent()">{{'NOTIFICATION_MESSAGE.CLOSE_NOTIFICATION_BUTTON.OK_GOT_IT' | translate}}</a>
                              <span ng-show="totalNotificationNumber > 0">{{currentNotificationNumber}}/{{totalNotificationNumber}}</span>
                          </div>
                       </div>
                  </div>`,
        replace: true,
        link: ($scope:ng.IScope, $element:any, $attrs:any) => {

            $scope.totalNotificationNumber = 0;
            $scope.currentNotificationNumber = 1;
            resetScopeVariablesAndTrain();

            $scope.isPeriodRetrived = false;
            FeatureNotificationService.getNotificationsPeriod().then(function(response:FeatureNotificationResponse) {
                if (response && response.featureNotificationList){

                    featureNotificationList = response.featureNotificationList;
                    $scope.isPeriodRetrived = true;
                }
            });

            // Everytime we modify url, the notifications queue is clean
            // to receive notifications for that specific queue
            $rootScope.$on('$routeChangeSuccess', function(event, current, previous){
                notifications = [];
                uniqueFeatureName = [];
                $scope.totalNotificationNumber = 0;
                $scope.currentNotificationNumber = 1;
                resetScopeVariablesAndTrain();
            })

            $rootScope.$on(SignalProvider.FeatureNotification.RegisterNotification, function(event, featureToNotify) {
                $log.info("Receiving feature notification request: " + featureToNotify.featureName);
                
                if (FeatureNotificationService.isValidNotification(featureToNotify.featureName, featureNotificationList)) {

                    notifications.push(featureToNotify);
                    $scope.newNotificationTrain = true;

                    // Increase unique feature name number
                    var uniqueFeatureNameIdx = uniqueFeatureName.indexOf(featureToNotify.featureName);
                    if (uniqueFeatureNameIdx < 0) {
                        uniqueFeatureName.push(featureToNotify.featureName);
                        $scope.totalNotificationNumber = uniqueFeatureName.length;
                    }
                }

            });

            var featureNotificationResizeHandler = _.debounce(function(){
                attachNotification($scope.targetElem, $scope.placement);
            }, 300);

            var featureNotificationClickHandler = _.debounce(function(){
                attachNotification($scope.targetElem, $scope.placement);
            }, 100);

            $scope.$watchCollection('[newNotificationTrain,isPeriodRetrived]', function(newCollection:any){
                if(newCollection[0] && newCollection[1]){

                    // Only if there is a notification train, we register events
                    angular.element($window).bind('resize', featureNotificationResizeHandler);
                    angular.element($window).bind('click', featureNotificationClickHandler);

                    showNextNotification();
                }
            });

            $scope.$watch(function getElementOffset() {
                // do not directly return offset as it triggers infinit digest.
                // use a string value to detect the changes
                return $scope.targetElem? $scope.targetElem.offset().left.toString() + $scope.targetElem.offset().top.toString(): null;
            }, function() {
                attachNotification($scope.targetElem, $scope.placement);
            });

            function resetScopeVariablesAndTrain() {
                $scope.featureName = undefined;
                $scope.title = undefined;
                $scope.content = undefined;
                $scope.targetElem = undefined;
                $scope.placement = undefined;

                $scope.showNotification = false;
                $scope.newNotificationTrain = false;
            }

            function showNextNotification(){

                // If all notification in array has been processed
                // set the train to false, to wait more notifications
                if (notifications.length == 0){
                    $log.info("No more feature notification requests in queue");

                    // Deregister the feature notification handlers' event
                    angular.element($window).unbind('resize', featureNotificationResizeHandler);
                    angular.element($window).unbind('click', featureNotificationClickHandler);

                    // Restart $scope variables
                    resetScopeVariablesAndTrain();

                    return;
                }

                var notification = notifications.shift();
                $log.info("Feature Notification to process: " + notification.featureName);

                $scope.featureName = notification.featureName;
                $scope.title = notification.title;
                $scope.content = notification.content;
                $scope.targetElem = notification.appendTo;
                $scope.placement = notification.placement;

                attachNotification($scope.targetElem, $scope.placement);
            }

            function attachNotification(target:any, placement:string) {

                if(!target || !placement){
                    return;
                }

                // wait for elements to be added to DOM
                $timeout(function() {

                    // Get the offset of the element to notify
                    var targetOffset = $uibPosition.offset(target);

                    // If target element is not visible don't display the beacon and notification
                    if (targetOffset.width == 0 && targetOffset.height == 0) {
                        $log.info("Target of notification doesn't exists any more");
                        $scope.showNotification = false;
                        showNextNotification();
                        return;
                    }

                    var elemOffset = $uibPosition.offset($element);
                    switch(placement) {
                        case 'top':
                            elemOffset.top = targetOffset.top - elemOffset.height - NOTIFICATION_SPACE;
                            elemOffset.left = targetOffset.left + targetOffset.width/2 - elemOffset.width/2;
                            break;
                        case 'right':
                            elemOffset.top = targetOffset.top + targetOffset.height/2 - elemOffset.height/2;
                            elemOffset.left = targetOffset.left + targetOffset.width + NOTIFICATION_SPACE;
                            break;
                        case 'bottom':
                            elemOffset.top = targetOffset.top + targetOffset.height + NOTIFICATION_SPACE;
                            elemOffset.left = targetOffset.left + targetOffset.width/2 - elemOffset.width/2;
                            break;
                        case 'left':
                            elemOffset.top = targetOffset.top + targetOffset.height/2 - elemOffset.height/2;
                            elemOffset.left = targetOffset.left - elemOffset.width - NOTIFICATION_SPACE;
                            break;
                    }

                    $element.css({top: elemOffset.top, left: elemOffset.left});
                    $scope.showNotification = true;
                    $scope.$apply();

                }, 0, false);
            }

            $scope.hideCurrent = function() {
                //Store in local storage that it has been selected.
                FeatureNotificationService.acknowledgeFeature($scope.featureName);

                $scope.showNotification = false;
                $scope.currentNotificationNumber++;
                showNextNotification();
            };

        }
    };
}])
.directive('featureNotification', ['$log', 'FeatureManagerService', 'Features', ($log:ng.ILogService, FeatureManagerService:any, Features:any) => {
    return {
        link: ($scope:ng.IScope, $element:any, $attrs:any) => {

            if (!FeatureManagerService.isFeatureEnabled(Features.UI.FEATURE_NOTIFICATION)) {
                return;
            }

            if ($attrs.notificationReady !== undefined) {
                $scope.$watch($attrs.notificationReady, (newVal, oldVal) => {
                    // If ready state is initially true or changed to true later
                    if (newVal || (newVal !== oldVal && newVal)) {
                        sendNotification();
                    }
                });
            } else {
                sendNotification();
            }

            function sendNotification() {
                var featureToNotify:any = {
                    featureName: $attrs.featureNotification,
                    title: $attrs.notificationTitle,
                    content: $attrs.notificationContent,
                    placement: (!$attrs.notificationPlacement)? 'bottom': $attrs.notificationPlacement,
                    appendTo: $element
                };

                $scope.$emit(SignalProvider.FeatureNotification.RegisterNotification, featureToNotify);
            }

            
        }
    };
}])
